import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrMG: CultureInfo = {
  name: 'fr-MG',
  displayName: 'français (Madagascar)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-MG',
  parent: CultureInfoFr
};
